import { API, graphqlOperation } from "aws-amplify";
import { FeatureFlag } from "../API";
import { listFeatureFlags } from "../graphql/queries";
import { IConnectListQuery } from "../types";

let flags: Record<string, FeatureFlag> | undefined = undefined;
let loadingPromise: Promise<any>;
const loadFlags = async () => {
  let _flags: Record<string, FeatureFlag> = {};
  if (loadingPromise) {
    return loadingPromise;
  }
  loadingPromise = new Promise(async (resolve) => {
    let nextToken = null;
    do {
      const batch = await API.graphql(graphqlOperation(listFeatureFlags, {
        nextToken,
        limit: 20,
      })) as IConnectListQuery<
        FeatureFlag,
        'listFeatureFlags'
      >;;
      for (const i in batch.data['listFeatureFlags']?.items) {
        const item = batch.data['listFeatureFlags']?.items[i];
        _flags[item.name] = item;
      }
      nextToken = batch.data['listFeatureFlags']?.nextToken;
    } while (nextToken)
    flags = _flags;
    resolve(_flags);
  });
  await loadingPromise;
  return _flags;
};

export async function isFlagEnabled(name: string, context?: Record<string, unknown>): Promise<boolean> {
  if (!flags) {
    await loadFlags();
  }
  if (!flags) {
    return false;
  }
  if (!flags[name]) {
    return false;
  }
  if (!flags[name].enabled) {
    return false;
  }
  if (flags[name].condition && typeof flags[name].condition === 'string') {
    const condition = JSON.parse(flags[name].condition as string);
    for (const attr in condition) {
      const attrCondition = condition[attr];
      switch (typeof attrCondition) {
        case 'string': case 'number':
          // Simple condition, match to context exactly
          if ((context || {})[attr] !== condition[attr]) {
            // Context does not match condition
            return false;
          }
          break;
        case 'object':
          // List of values
          if (attrCondition.indexOf((context || {})[attr]) === -1) {
            // The value for this attribute from the context does not exist in the list of conditions
            return false;
          }
          break;
      }
    }
    return true;
  }
  // Flag is defined
  return true;
}